import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { EmitterService } from '../../services/emitter.service';
import { PlatformEventService } from '../../services/platform-events.service';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MaintenanceUpdatedEvent } from '../../models';
import { BannerState } from '../../interfaces';

const PLATFORM_BANNER = {
  SCHEDULED_MAINTENANCE: 'SCHEDULED_MAINTENANCE',
};

export enum BannerTypes {
  MaintenanceOnly = 'MaintenanceOnly',
  All = 'All',
}

@Component({
  selector: 'mtm-banner',
  templateUrl: './info-banner.component.html',
  styleUrl: './info-banner.component.scss',
  standalone: false,
})
export class InfoBannerComponent implements OnInit, OnDestroy {
  @Input() bannerType = BannerTypes.MaintenanceOnly;
  authUser: any;
  banner: any;
  platformEvents: any = [];
  scheduledMaintenance: any = null;
  ngUnsubscribe = new Subject();
  bannerTypes = BannerTypes;
  messageLines: string[] = [];
  bannerState: BannerState = {
    hidden: false,
  };

  constructor(
    private readonly authService: AuthService,
    private readonly platformEventService: PlatformEventService
  ) {}

  get isCloseBannerVisible() {
    return this.authUser?.username && !this.bannerState?.hidden;
  }

  ngOnInit() {
    this.authUser = this.authService.getAuthUser();
    this.bannerState = this.platformEventService.getBannerState();
    EmitterService.get(MaintenanceUpdatedEvent)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: () => {
          this.banner = null;
          this.scheduledMaintenance = null;
          this.loadData();
        },
      });

    this.loadData();
  }

  private loadData() {
    this.platformEventService
      .getPlatformEventInfo()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.platformEvents = [...res];
        this.checkBanner();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  checkBanner() {
    if (this.platformEvents.length) {
      for (const event of this.platformEvents) {
        if (event.code === 'SCHEDULED_DEPLOYMENT') {
          const today = moment().utc(),
            endTime = moment(event.endTime).utc();
          if (endTime > today) {
            const scheduledInfo = JSON.parse(event.objectJson);
            this.banner = PLATFORM_BANNER.SCHEDULED_MAINTENANCE;
            this.scheduledMaintenance = {};
            this.scheduledMaintenance.startTime = `${scheduledInfo.startDate.year}-${scheduledInfo.startDate.month}-${scheduledInfo.startDate.day} ${scheduledInfo.startTime.hour}:${scheduledInfo.startTime.minute}`;
            this.scheduledMaintenance.endTime = `${scheduledInfo.endDate.year}-${scheduledInfo.endDate.month}-${scheduledInfo.endDate.day} ${scheduledInfo.endTime.hour}:${scheduledInfo.endTime.minute}`;
            this.scheduledMaintenance.timezone = scheduledInfo.timezone;
            this.messageLines = scheduledInfo.message?.split('\n') || [];
          }
        }
      }
    } else {
      this.banner = void 0;
    }
  }

  closeBanner() {
    this.bannerState.hidden = true;
    this.platformEventService.saveBannerState(this.bannerState);
  }
}
